import React from 'react';

const Battery = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 100 100" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <path fill="currentColor" d="M89.6 38.09V80.7H10.4V38.09h79.2m5.4-5.32H5v53.26h90V32.77z" />
    <path
      fill="currentColor"
      d="M62.6 55.33h18v5.33h-18zM36.95 55.33h-6.3v-6.21h-5.4v6.21h-6.3v5.33h6.3v6.21h5.4v-6.21h6.3zM93.2 28.23h-5.4v-2.88H77.46v-6h-6.69v6H29.23v-6h-6.69v6H12.2v2.88H6.8v-8.21h10.34v-5.99h17.49v5.99h30.74v-5.99h17.49v5.99H93.2z"
    />
  </svg>
);

export default Battery;



// WEBPACK FOOTER //
// ./src/common/icons/Battery.js